import React from "react"
import { graphql } from "gatsby"
import Layout from "../containers/Layout"
import SEO from "../components/seo"
import { Container } from "../components/Container"
import BlogHighlight from "../sections/BlogHighlight"
import Card from "../components/Card"
import { useLangFilter } from "../hooks"
import { CardContainer } from "../containers/CardContainer"
import BgBlue from "../assets/bg-blue.svg"
import { FormattedMessage } from "gatsby-plugin-intl"

const BlogPage = ({ data: { allContentfulBlogPost } }) => {
  const postList = useLangFilter(allContentfulBlogPost.edges)

  return (
    <Layout>
      <SEO intlId="blog" />
      <Container>
        <BgBlue
          style={{ position: "absolute", left: 0, opacity: 0.4, zIndex: -1 }}
        />
        <section className="p-4 mx-auto mb-4">
          <h4 className="xs:text-base md:text-3xl xs:font-normal md:font-semibold">
            <FormattedMessage id="blog.subtitle" />
          </h4>
          <h1 className="xs:text-2xl md:text-6xl font-semibold mb-2">
            <FormattedMessage id="blog.title" />
          </h1>
          <h2 className="xs:text-base md:text-3xl xs:font-normal md:font-semibold">
            <FormattedMessage id="blog.text" />
          </h2>
        </section>
        <BlogHighlight />
        <hr className="my-8" />
        <section className="xs:block md:flex flex-wrap xs:p-0 md:p-8">
          {postList.map(({ node }, i) => {
            return (
              <CardContainer key={i}>
                <Card
                  img={node.image && node.image.fluid}
                  title={node.title || node.name}
                  date={node.createdAt}
                  slug={"/" + node.slug}
                  text={false ? undefined : node.description}
                  labels={node.labels.split(",")}
                  online={node.online}
                  github={node.github}
                />
              </CardContainer>
            )
          })}
        </section>
      </Container>
    </Layout>
  )
}

export default BlogPage

export const listQuery = graphql`
  query ListQuery {
    allContentfulBlogPost(sort: { fields: createdAt, order: DESC }) {
      edges {
        node {
          createdAt(fromNow: false)
          description
          labels
          node_locale
          slug
          title
          body {
            id
            body
          }
          id
          image {
            fluid(maxWidth: 786) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  }
`
